import { createSlice } from '@reduxjs/toolkit'
import { getEnabledPrinters } from 'state/Printers'
import { refreshRestaurants } from 'state/Restaurants'
import { Locale, SupportChat, useObjSelector } from 'utils'
import HTTP_CODE from 'utils/HTTP_CODE'
import API from './API'
import TabletOptions from './models/TabletOptions'

const initialState = {
	settings: {},
	update  : 0,
}

const slice = createSlice({
	name    : 'settings',
	initialState,
	reducers: {
		setSettings  : (state, { payload: settings }) => { state.settings = settings },
		clearSettings: () => initialState,
		setSetting   : (settings, { payload }) => { Object.assign(settings, payload) },

		setUpdatesVersion: (state, { payload: version }) => { state.update = version },
	},
})

//not exactly official, but enough for some organization
slice.thunks = {
	saveSettings: settings => async (dispatch, getState) => {
		SupportChat.fromState(getState())?.event('Saved settings') //would be nice if we could also store the payload of changed options
		const newSettings = (await API.post('user/options', settings)).data
		dispatch(slice.actions.setSettings(newSettings))
	},
	saveSetting : (field, value) => async (dispatch, getState) => {
		SupportChat.fromState(getState())?.event('Saved settings') //would be nice if we could also store the payload of changed options
		const newSettings = (await API.post(`user/option/${field}`, value)).data
		dispatch(slice.actions.setSettings(newSettings))
	},
	logFeatures: ({ auto_print = undefined } = {}) => async (dispatch, getState) => {
		if (auto_print === undefined) {
			auto_print = getEnabledPrinters(getState()).length >= 1
		}
		return API.post('user/log_features', { auto_print })
	},
	saveLocale: locale => async (dispatch) => {
		await new Locale().set(locale) //this is awaited as it could cause errors in development stage

		return API.patchAndHandle(`user/locale/${locale}`, HTTP_CODE.NOT_ACCEPTABLE__406)
			.catch(e => {
				if (e.response.status === HTTP_CODE.NOT_ACCEPTABLE__406) {
					console.error(`Invalid locale "${locale}" in the backend. Valid options: ${e.response.data?.error?.valid_locales?.join(', ') || '*list not given*'}`)
				}
			})
			.finally(() => dispatch(refreshRestaurants)) //so restaurant status times come properly translated from the backend)
	}
}

/**
 * @internal Avoid using it in components - useSettings is better, as it avoids useless re-renders.
 * @return {TabletOptions}
 */
export const getSettings       = ({ settings: { settings } }) => new TabletOptions(settings)
/** @return {TabletOptions} */
export const useSettings       = () => useObjSelector(getSettings)
export const getUpdatesVersion = ({ settings: { update } }) => update

export const { setSettings, setSetting, clearSettings, setUpdatesVersion } = slice.actions
export const { saveSettings, saveSetting, logFeatures, saveLocale }        = slice.thunks
export default slice.reducer
